import { Row, Col } from "antd";
import { DollarSign, Printer, Book, PlusSquare, Send, FileText } from "lucide-react";
import DataGroup from "../../DataGroup";
import DataItem from "../../DataItem";

export default function GeneralSection(props) {
  const { verification, setVerification, hidden, loading } = props;

  const responsiveInfo = {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 8,
  };

  return (
    <Row gutter={[16, 16]}>
      <Col {...responsiveInfo}>
        <DataGroup
          title={"General"}
          formName={"Información general"}
          mainData={verification}
          setMainData={setVerification}
          verification={verification}
        >
          <DataItem
            keyName="Descripción breve"
            value={verification?.DescripcionBreve}
            fieldWidth={8}
            hidden={hidden}
            loading={loading}
          />
          <DataItem
            icon={<DollarSign size={16} />}
            iconColor="#82cc4b "
            keyName="Monto de contrato"
            value={verification?.Monto}
            valueType="double"
            fieldWidth={8}
            hidden={hidden}
            prefix="$"
            loading={loading}
          />
          <DataItem
            icon={<Printer size={16} />}
            iconColor="#1890ff "
            keyName="Folio interno"
            value={verification?.FolioAmuvie}
            valueType="string"
            fieldWidth={8}
            hidden={hidden}
            loading={loading}
          />
          <DataItem
            icon={<Book size={16} />}
            iconColor="#802917 "
            keyName="Folio Sediver"
            value={verification?.FolioSediver}
            valueType="string"
            fieldWidth={8}
            hidden={hidden}
            loading={loading}
          />
        </DataGroup>
      </Col>
      <Col {...responsiveInfo}>
        <DataGroup
          title={"Fechas"}
          formName={"Fechas"}
          mainData={verification}
          setMainData={setVerification}
          verification={verification}
        >
          <DataItem
            icon={<PlusSquare size={16} />}
            iconColor="#1890ff"
            keyName="Fecha de creación"
            value={verification?.FechaCreacion}
            valueType="date"
            fieldWidth={8}
            hidden={hidden}
            loading={loading}
          />
          <DataItem
            icon={<Send size={16} />}
            iconColor="#82cc4b"
            keyName="Fecha de la solicitud"
            value={verification?.FechaRecepcion}
            valueType="date"
            fieldWidth={8}
            hidden={hidden}
            loading={loading}
          />
          <DataItem
            icon={<FileText size={16} />}
            iconColor="#ffc53d"
            keyName="Fecha del contrato"
            value={verification?.FechaContrato}
            valueType="date"
            fieldWidth={8}
            hidden={hidden}
            loading={loading}
          />
        </DataGroup>
      </Col>
    </Row>
  );
}